import * as yup from 'yup'
import { INTERNAL_ROLE_NAME_MAX_LENGTH } from 'src/constants/internal-access/internalRoles'

/** Mirrors `InternalAccessRolesCreateDto`: trimmed, non-empty, ≤ 64; an empty list is allowed. */
export const internalRoleFormValidator = yup.object({
  name: yup
    .string()
    .trim()
    .required('Role name is required')
    .max(
      INTERNAL_ROLE_NAME_MAX_LENGTH,
      `Role name must be at most ${INTERNAL_ROLE_NAME_MAX_LENGTH} characters`,
    ),
  permissions: yup.array(yup.string().required()).required(),
})
